var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialSymbolsEditOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.25H6.4L15.025 10.625L13.625 9.225L5 17.85V19.25ZM19.3 9.175L15.05 4.975L16.45 3.575C16.8333 3.19167 17.3043 3 17.863 3C18.4217 3 18.8923 3.19167 19.275 3.575L20.675 4.975C21.0583 5.35833 21.2583 5.821 21.275 6.363C21.2917 6.905 21.1083 7.36733 20.725 7.75L19.3 9.175ZM17.85 10.65L7.25 21.25H3V17L13.6 6.4L17.85 10.65ZM14.325 9.925L13.625 9.225L15.025 10.625L14.325 9.925Z",
    fill: "#ED583B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsEditOutline);
export default __webpack_public_path__ + "static/media/material-symbols_edit-outline.127b8ca47c4eaf421ed4923543f175dc.svg";
export { ForwardRef as ReactComponent };